<template>
  <footer class="vz-footer">
    <div class="vz-footer-content">
      <div class="vz-footer-section vz-footer-logo">
        <nuxt-link class="vz-logo" to="/" aria-label="Início">
          <strong>{{ $store.state.config.title || 'Vizzto' }} </strong>
        </nuxt-link>
      </div>

      <section
        class="vz-footer-section"
        v-for="section in sections"
        :key="section.id"
      >
        <h2 class="vz-section-title">
          {{ section.label }}
        </h2>
        <ul>
          <li v-for="item in section.items" :key="item.id">
            <vz-link
              v-if="item.label === 'Política de privacidade'"
              class="vz-footer-link"
              :to="item.link"
            >
              <i class="ic-placeholder vz-footer-link-ic"></i>
              {{ item.label }}
            </vz-link>
          </li>
        </ul>
      </section>
    </div>
  </footer>
</template>

<script>
import VzLink from 'vsp-web-ui-lib/components/atoms/vz-link.vue';

export default {
  name: 'Footer',
  components: {
    VzLink
  },

  props: {
    sections: {
      type: Array,
      default: () => []
    }
  }
};
</script>





































































































































































<style theme="light-theater" scoped>
.vz-footer {
  width: 100%;
  background-color: var(--primary-color);
  font-size: 0.874em;
}

.vz-footer-content {
  padding: 32px 32px;
  width: 100%;
}

.vz-logo {
  display: inline-block;
  width: 180px;
  height: 72px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-image: var(--logo-footer-bar);
  border-bottom-width: 0;
}

.vz-logo strong {
  display: none;
}

.vz-section-title {
  display: none;
  border-bottom-width: 0;
}

.vz-footer-link {
  color: var(--primary-color-contrast);
  border-bottom-width: 0;
  display: block;
}

.vz-footer-link:hover {
  color: var(--primary-color-over-contrast);
}

.vz-footer-link:active {
  color: var(--link-color-active);
}

.vz-footer-link-ic {
  display: none;
}

.vz-footer-link[href*='facebook.com'] .vz-footer-link-ic,
.vz-footer-link[href*='twitter.com'] .vz-footer-link-ic,
.vz-footer-link[href*='instagram.com'] .vz-footer-link-ic,
.vz-footer-link[href*='youtube.com'] .vz-footer-link-ic,
.vz-footer-link[href*='maps.google.com'] .vz-footer-link-ic,
.vz-footer-link[href^='mailto:'] .vz-footer-link-ic,
.vz-footer-link[href^='tel:'] .vz-footer-link-ic {
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
  margin-right: 8px;
}

.vz-footer-link[href*='facebook.com'] .vz-footer-link-ic,
.vz-footer-link[href*='twitter.com'] .vz-footer-link-ic,
.vz-footer-link[href*='instagram.com'] .vz-footer-link-ic,
.vz-footer-link[href*='youtube.com'] .vz-footer-link-ic {
  color: #ffffff;
}

.vz-footer-link[href*='maps.google.com'] .vz-footer-link-ic,
.vz-footer-link[href^='mailto:'] .vz-footer-link-ic,
.vz-footer-link[href^='tel:'] .vz-footer-link-ic {
  color: rgba(255, 255, 255, 0.75);
}

.vz-footer-link[href*='facebook.com'] .vz-footer-link-ic:before {
  content: '\e938';
}

.vz-footer-link[href*='twitter.com'] .vz-footer-link-ic:before {
  content: '\e99a';
}

.vz-footer-link[href*='instagram.com'] .vz-footer-link-ic:before {
  content: '\e94a';
}

.vz-footer-link[href*='youtube.com'] .vz-footer-link-ic:before {
  content: '\e9ac';
}

.vz-footer-link[href*='maps.google.com'] .vz-footer-link-ic:before {
  content: '\e955';
}

.vz-footer-link[href^='mailto:'] .vz-footer-link-ic:before {
  content: '\e954';
}

.vz-footer-link[href^='tel:'] .vz-footer-link-ic:before {
  content: '\e986';
}

.vz-footer-section {
  margin-top: 32px;
}

.vz-footer-section ul {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.vz-footer-section li {
  list-style: none;
}

.vz-footer-logo {
  text-align: center;
  margin: 0 0 32px;
}

@media (min-width: 1024px) {
  .vz-footer-content {
    margin: 0;
    padding: 32px 64px;
    display: grid;
    grid-template-columns: 23.8% 23.8% 1fr;
    row-gap: 48px;
    align-items: end;
  }

  .vz-footer-logo {
    margin: 0;
    text-align: left;
  }

  .vz-logo {
    background-position: left center;
  }

  .vz-footer-section {
    margin: 0;
  }

  .vz-footer-section:nth-child(2),
  .vz-footer-section:nth-child(4) {
    grid-column-start: 3;
  }

  .vz-footer-section:nth-child(2) li {
    display: inline-block;
    margin-left: 32px;
  }

  .vz-footer-section:nth-child(4) {
    margin-left: 32px;
  }
}
</style>
